@use '@fukuri-admins/ui/layout' as *;

.LoginFormContent {
  padding: 30px 35px;
  box-sizing: border-box;
  width: 620px;
  height: fit-content;
  background: $White;
  box-shadow: 0px 0px 30px rgba(55, 55, 79, 0.05);
  border-radius: 10px;

  @media (max-width: 769px) {
    min-width: 100%;
    width: 100%;
  }

  &__Title {
    text-align: center;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    color: $NATURAL_600;
  }

  &__ErrorMessage {
    color: $TextError;
    font-weight: 600;
    font-size: 14px;
    text-align: center;
    margin: 12px 0;
  }

  &__Form {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  &__SubmitButton {
    width: 100%;
    height: 48px;
    background: $NATURAL_800;
    color: $White;
    font-size: 16px;
    font-weight: 600;
    border-radius: 10px;

    &:disabled {
      background: $NATURAL_300;
      color: $White;
      cursor: not-allowed;
    }
  }
}
